import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<{ iconUrl?: string; sizeInSpacing: number }, 'avatar'>()(
  (theme, { sizeInSpacing }, classes) => ({
    root: {
      position: 'relative',
      width: theme.spacing(sizeInSpacing),
      height: theme.spacing(sizeInSpacing),
      minWidth: theme.spacing(sizeInSpacing),

      '&.MuiBox-root': {
        fontSize: theme.spacing(2),
      },

      '& img': {
        width: '100%',
        height: '100%',
      },
    },
    withHover: {
      cursor: 'pointer',

      [`& .${classes.avatar}:hover`]: {
        border: `${theme.spacing(0.25)} solid ${theme.palette.primary.main}`,
        boxShadow: `0px 0px ${theme.spacing(1)} 0 ${theme.palette.primary.dark}`,
      },
    },
    avatar: {
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      borderRadius: '50%',
      border: `${theme.spacing(0.25)} solid ${theme.palette.secondary.dark}`,
      width: theme.spacing(sizeInSpacing),
      height: theme.spacing(sizeInSpacing),
      overflow: 'hidden',
    },
    status: {
      position: 'absolute',
      border: `${theme.spacing(0.25)} solid ${theme.palette.background.default}`,
      borderRadius: theme.spacing(0.875),
      backgroundColor: theme.palette.secondary.dark,
      width: theme.spacing(1.75),
      height: theme.spacing(1.75),
      right: 0,
      bottom: 0,

      '&.online': {
        border: `${theme.spacing(0.25)} solid ${theme.palette.background.default}`,
        backgroundColor: theme.palette.success.light,
      },
    },
  })
);
